module.exports = __webpack_public_path__ + "static/media/SFST_1-1440w.c3298b13.jpg";